import { format } from 'date-fns';
import { shallowEqual, useSelector } from 'react-redux';
var useSelectedDispute = function () {
    return useSelector(function (_a) {
        var _b, _c;
        var appConfig = _a.appConfig, disputes = _a.allDisputes.disputes;
        var _d = appConfig.selectedDispute, caseId = _d.caseId, transactionId = _d.transactionId;
        var selectedDispute = disputes.find(function (dispute) { return dispute.caseId === caseId; });
        var selectedTransaction = selectedDispute.transactions.find(function (transaction) { return transaction.id === transactionId; });
        var unsortedDisputeDocuments = ((_b = selectedTransaction.documentsUploaded) === null || _b === void 0 ? void 0 : _b.slice()) || [];
        var uploadedDisputeDocuments = unsortedDisputeDocuments.sort(function (a, b) { return Date.parse(b.uploadDate) - Date.parse(a.uploadDate); });
        var transactionDisputeHistory = ((_c = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.disputeHistory) === null || _c === void 0 ? void 0 : _c.slice().sort(function (a, b) { return Date.parse(b.date) - Date.parse(a.date); }).map(function (_a) {
            var _b, _c;
            var additionalCaseNotes = _a.additionalCaseNotes, caseStatus = _a.statusCode, date = _a.date, documentsCount = _a.documentsCount;
            var formattedDate = format(new Date(date), 'MMM d, yyyy');
            /*
             * Opening of a dispute and the uploading of documents were both being flagged as originating from 'SYNCHRONY'
             * due to the original formattedAddedBy logic. Updating to manually set those two use cases to 'CUSTOMER', then using
             * the previous logic as a fallback for any other cases.
             */
            var formattedAddedBy = documentsCount || caseStatus === 'SET_1'
                ? 'CUSTOMER'
                : (_b = additionalCaseNotes[0]) === null || _b === void 0 ? void 0 : _b.notesAddedBy.toUpperCase();
            return {
                caseStatus: caseStatus,
                date: formattedDate,
                documentsCount: documentsCount,
                notes: (_c = additionalCaseNotes[0]) === null || _c === void 0 ? void 0 : _c.notes,
                notesAddedBy: formattedAddedBy !== null && formattedAddedBy !== void 0 ? formattedAddedBy : 'SYNCHRONY'
            };
        })) || [];
        return {
            selectedDispute: selectedDispute,
            selectedTransaction: selectedTransaction,
            transactionDisputeHistory: transactionDisputeHistory,
            uploadedDisputeDocuments: uploadedDisputeDocuments
        };
    }, shallowEqual);
};
export default useSelectedDispute;
//# sourceMappingURL=useSelectedDispute.js.map